import { clsx } from 'clsx';
import { useSearchParams } from 'react-router-dom';
import { BannerWithGraphic } from '@mosey/components/layout/BannerWithGraphic';
import inboxZeroImg from '../../../assets/tasks-framework/tasks-overview-inbox-zero.svg';
import automatedZeroImg from '../../../assets/tasks-framework/tasks-overview-automated-zero.svg';
import managedZeroImg from '../../../assets/tasks-framework/tasks-overview-managed-zero.svg';

export const TasksOverviewZeroState = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  let title = 'Inbox zero';
  let body: React.ReactNode = 'You have no tasks due this month.';
  let imgSrc = inboxZeroImg;

  switch (status) {
    case 'overdue':
      title = 'You’re all caught up!';
      body = 'You have no overdue tasks.';
      break;

    case 'done':
      title = 'No completed tasks yet.';
      body = 'Tasks will show up here as you complete them.';
      break;

    case 'automated':
      title = 'No completed automations yet.';
      body = 'Automated tasks will show up here as they are completed.';
      imgSrc = automatedZeroImg;
      break;

    case 'managed':
      title = 'No managed tasks yet.';
      body = 'Tasks handled by integrations will show up here.';
      imgSrc = managedZeroImg;
      break;
  }

  return (
    <BannerWithGraphic
      title={title}
      body={body}
      variant={
        status === 'automated' || status === 'managed'
          ? 'automation'
          : 'default'
      }
      graphic={
        <img
          src={imgSrc}
          className={clsx(
            status === 'automated' && 'mr-20 mt-12',
            status === 'managed' && 'mt-12',
          )}
          alt=""
        />
      }
    />
  );
};
